import { useMediaQuery } from "react-responsive";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import {
  shouldShowConsentAndPaySubscriptionBillingDisclaimer,
  shouldShowSidebarSubscriptionBillingDisclaimer,
} from "@jti/commerce/shared";
import { BREAKPOINT_MEDIUM } from "@jti/fe-common";
import type { OrderItem } from "@jti/magento";

import { categorizeItems } from "@checkout/utils/categorizeItems";

export const useCheckoutSubscriptionDisplayState = (items: OrderItem[] = []) => {
  const isDesktopView = useMediaQuery({ minWidth: BREAKPOINT_MEDIUM });
  const checkoutConfiguration = useCheckoutConfiguration();

  const { subscriptionItems } = categorizeItems(items);
  const showSubscriptionSummary = subscriptionItems.length > 0;

  return {
    subscriptionItems,
    showSubscriptionSummary,
    showSidebarBillingDisclaimer:
      showSubscriptionSummary &&
      shouldShowSidebarSubscriptionBillingDisclaimer(checkoutConfiguration.subscriptionTermsPlacement, isDesktopView),
    showConsentAndPaySubscriptionBillingDisclaimer:
      showSubscriptionSummary &&
      shouldShowConsentAndPaySubscriptionBillingDisclaimer(
        checkoutConfiguration.subscriptionTermsPlacement,
        isDesktopView
      ),
  };
};
